'use strict';

import Vue from 'vue';
import moment from 'moment';
import educationStep from '@/components/locum/complete profile steps/Education.vue';
import bankingStep from '@/components/locum/complete profile steps/PaymentDetails.vue';
import uploadIdStep from '@/components/locum/complete profile steps/UploadID.vue';
import ratesStep from '@/components/locum/complete profile steps/Rates.vue';
import experienceStep from '@/components/locum/complete profile steps/Experience.vue';
import locationsStep from '@/components/locum/complete profile steps/Locations.vue';
import AboutStep from '../components/locum/complete profile steps/About.vue';

import PracticeAddressStep from '@/components/practice/complete profile steps/Address.vue';
import PracticeOperationsStep from '@/components/practice/complete profile steps/Operations.vue';
import PracticeAboutStep from '@/components/practice/complete profile steps/About.vue';

import axios from 'axios';
import { bus } from '@/main';

import { Users } from '@/models/user.model';
import { Wallet } from '@/models/wallet.model';

const queryString = require('query-string');

export const store = {
	state: {
		//WIP avatar module. for asynchronous request for and storing of avatar images for use accross site.
		avatar_module: {
			requested: {},
			cache: {},
			no_avatar: require('@/assets/images/avatars/user.png'),
		},
		//
		practiceoffer: null,
		practiceLocumSearchResults: null,
		locumBroadSearch: 0,
		practiceLocumAvailabilitySlotSelected: null,
		locumPracticeRequestSelected: null,
		practiceViewingLocum: null,

		practiceBookingRequestsSent: null,
		practiceOfferSelected: null,

		adminViewingLocum: null,

		adminLastSearch: null,
		currentRoute: null,

		summaryTrackedAvailabilities: null,
		practiceRequestsSent: [],
		practiceLocumsAppliedTo: [],
		//
		notifications: [],
		//
		// channel notifications target a named channel rather than a global notification context.
		// pushing notification to a named channel increments the channels 'count' value,
		// popping a notification requires a identity and channel. Identities must be strings.
		// used on "accordion" items on dashboards - elsewhere may make use but this is primarily for use in accordions.
		//    NOTE : Disabled actually displaying these accordions, I require the 'true' state of notifications to be managed
		//           by the API, otherwise there may be cases where a notification will bever be "seen" due to its booking being manipulated outside of the frontend.
		channel_notifications: localStorage.getItem('channel_notifications') ? JSON.parse(localStorage.getItem('channel_notifications')) : {},
		//
		locumAvailabilitySelected: null,
		locumViewingPractice: null,
		//
		test: 'test-val',
		confirmedBookings: [],
		provinces_regions: [],
		public_holidays: [],
		availabilities: [], //create initial state of this for the site.
		offers: [], //locum and practice shared offer state, locums incoming offers and practice outgoing offers.
		booking_requests: [],
		bookings: [],
		calendar_events: [],
		cal_start_date: null,
		cal_end_date: null,
		user: {},
		cognitoUser: null,
		company: null,
		companies: [],
		cognitoUserGroups: [],
		jwtToken: null,
		profileButtonColours: {
			'verification-step': 'busy',
			'upload-id-step': 'negative',
			'education-step': 'negative',
			'banking-step': 'negative',
			'rates-step': 'negative',
			'experience-step': 'negative',
			'locations-step': 'negative',
			'about-step': 'negative',
			'create-account-step': 'positive',
			'operations-step': 'negative',
			'address-step': 'negative',
		},
		configs: { industries: {}, industriesV2: {}, industryKeys: {} }, // Object containing options (languages, industries, provinces, booking-cancellation-reasons, booking-status)
		//Company and Professional steps defined here.
		//text is the text appear in the "next step button"
		//context defines the named unique context of the step, it should match the component name on parent templates.
		companySteps: {
			context: 'complete-profile-steps',
			nextRequiredStep: false,
			levels: false,
			required_forms: [
				{
					text: 'Manager details',
					context: 'create-account-step', // this button cant change context
					image_o: require('@/assets/images/complete signup/orange/account.svg'),
					image_g: require('@/assets/images/complete signup/green/account.svg'),
					image_w: require('@/assets/images/complete signup/white/account.svg'),
					form: false,
					image_width: 50,
					image_height: 50,
					status: true,
				},
				{
					text: 'Account created',
					context: 'create-account-step', // this button cant change context
					image_o: require('@/assets/images/complete signup/orange/hospital.svg'),
					image_g: require('@/assets/images/complete signup/green/hospital.svg'),
					image_w: require('@/assets/images/complete signup/white/hospital.svg'),
					form: false,
					image_width: 50,
					image_height: 50,
					status: true,
				},
				{
					text: 'Verification',
					context: 'verification-step', // this button cant change context
					image_o: require('@/assets/images/complete signup/orange/verification.svg'),
					image_w: require('@/assets/images/complete signup/white/verification.svg'),
					image_g: require('@/assets/images/complete signup/green/verification.svg'),
					form: false,
					image_width: 50,
					image_height: 50,
					status: false,
				},
				{
					text: 'Practice address',
					context: 'address-step', // this button changes context
					image_o: require('@/assets/images/complete signup/orange/location.svg'),
					image_w: require('@/assets/images/complete signup/white/location.svg'),
					image_g: require('@/assets/images/complete signup/green/location.svg'),
					form: PracticeAddressStep,
					image_width: 50,
					image_height: 50,
					button_text: 'practice address',
					status: false,
				},
				{
					text: 'Operations',
					context: 'operations-step', // this button cant change context
					image_o: require('@/assets/images/complete signup/orange/operations.svg'),
					image_w: require('@/assets/images/complete signup/white/operations.svg'),
					image_g: require('@/assets/images/complete signup/green/operations.svg'),
					form: PracticeOperationsStep,
					image_width: 50,
					image_height: 50,
					button_text: 'operations',
					status: false,
				},
				{
					text: 'About',
					context: 'about-step', // this button cant change context
					image_o: require('@/assets/images/complete signup/orange/icircle.svg'),
					image_w: require('@/assets/images/complete signup/white/icircle.svg'),
					image_g: require('@/assets/images/complete signup/green/icircle.svg'),
					form: PracticeAboutStep,
					image_width: 50,
					image_height: 50,
					button_text: 'about practice',
					status: false,
				},
			],
		},
		professionalSteps: {
			context: 'complete-profile-steps',
			nextRequiredStep: false,
			nextBoosterStep: false,
			levels: false,
			required_forms: [
				{
					text: 'Account Created',
					context: 'create-account-step', // this button cant change context
					image_o: require('@/assets/images/complete signup/orange/account.svg'),
					image_g: require('@/assets/images/complete signup/green/account.svg'),
					image_w: require('@/assets/images/complete signup/white/account.svg'),
					form: false,
					image_width: 50,
					image_height: 50,
					status: true,
				},
				{
					text: 'Verification',
					context: 'verification-step', // this button cant change context
					image_o: require('@/assets/images/complete signup/orange/verification.svg'),
					image_w: require('@/assets/images/complete signup/white/verification.svg'),
					image_g: require('@/assets/images/complete signup/green/verification.svg'),
					form: false,
					image_width: 50,
					image_height: 50,
					status: false,
				},
				{
					text: 'Upload ID',
					context: 'upload-id-step', // this button changes context
					image_o: require('@/assets/images/complete signup/orange/uploadid.svg'),
					image_w: require('@/assets/images/complete signup/white/uploadid.svg'),
					image_g: require('@/assets/images/complete signup/green/uploadid.svg'),
					form: uploadIdStep,
					image_width: 50,
					image_height: 50,
					button_text: 'Upload ID',
					status: false,
				},
				{
					text: 'Experience',
					context: 'experience-step', // this button cant change context
					image_o: require('@/assets/images/complete signup/orange/experience.svg'),
					image_w: require('@/assets/images/complete signup/white/experience.svg'),
					image_g: require('@/assets/images/complete signup/green/experience.svg'),
					form: experienceStep,
					image_width: 50,
					image_height: 50,
					button_text: 'Experience',
					status: false,
				},
				{
					text: 'Rates',
					context: 'rates-step', // this button cant change context
					image_o: require('@/assets/images/complete signup/orange/rates.svg'),
					image_w: require('@/assets/images/complete signup/white/rates.svg'),
					image_g: require('@/assets/images/complete signup/green/rates.svg'),
					form: ratesStep,
					image_width: 50,
					image_height: 50,
					button_text: 'Rates',
					status: false,
				},
			],
			booster_forms: [
				{
					text: 'Education',
					context: 'education-step', // this button cant change context
					image_o: require('@/assets/images/complete signup/orange/education.svg'),
					image_w: require('@/assets/images/complete signup/white/education.svg'),
					image_g: require('@/assets/images/complete signup/green/education.svg'),
					form: educationStep,
					image_width: 50,
					image_height: 50,
					button_text: 'Education',
					status: false,
				},
				{
					text: 'Preferred Locations',
					context: 'locations-step', // this button cant change context
					image_o: require('@/assets/images/complete signup/orange/location.svg'),
					image_w: require('@/assets/images/complete signup/white/location.svg'),
					image_g: require('@/assets/images/complete signup/green/location.svg'),
					form: locationsStep,
					image_width: 50,
					image_height: 50,
					button_text: 'Preferred Location',
					status: false,
				},
				{
					text: 'About You',
					context: 'about-step', // this button cant change context
					image_o: require('@/assets/images/complete signup/orange/about.svg'),
					image_w: require('@/assets/images/complete signup/white/about.svg'),
					image_g: require('@/assets/images/complete signup/green/about.svg'),
					form: AboutStep,
					image_width: 50,
					image_height: 50,
					button_text: 'Bio & About You',
					status: false,
				},
				{
					text: 'Payment Info',
					context: 'banking-step',
					image_o: require('@/assets/images/complete signup/orange/banking.svg'),
					image_w: require('@/assets/images/complete signup/white/banking.svg'),
					image_g: require('@/assets/images/complete signup/green/banking.svg'),
					form: bankingStep,
					image_width: 50,
					image_height: 50,
					button_text: 'Payment Info',
					status: false,
				},
				// {
				//   "text"  : "Calendar",
				//   "context" : 'calendar-step', // this button cant change context
				//   "image_o" : require("@/assets/images/complete signup/orange/about.svg"),
				//   "image_w" : require("@/assets/images/complete signup/white/about.svg"),
				//   "image_g" : require("@/assets/images/complete signup/green/about.svg"),
				//   "form" : calendarStep,
				//   "image_width" : 50,
				//   "image_height" : 50,
				//   "button_text" : "calendar step",
				//   "status" : false,
				// },
			],
		},
	},
	mutations: {
		SET_ADMIN_LAST_SEARCH(state, value) {
			state.adminLastSearch = value;
		},
		SET_CURRENT_ROUTE(state, value) {
			state.currentRoute = value;
		},
		SET_PROFILE_BUTTON_TO_POSITIVE(state, payload) {
			state.profileButtonColours[payload] = 'positive';
		},
		SET_PROFILE_BUTTON_TO_NEGATIVE(state, payload) {
			state.profileButtonColours[payload] = 'negative';
		},
		SET_CONFIRMED_BOOKINGS(state, listOfBookings) {
			for (const booking of listOfBookings) {
				if (booking.status === 'confirmed') {
					state.confirmedBookings.push(booking);
				}
			}
		},
		CHANGE_PROFESSION(state, newProfession) {
			state.user.profession = newProfession;
		},
		CHANGE_INDUSTRY(state, newIndustry) {
			state.user.industry = newIndustry;
		},
		//push to a channel a notification object.
		PUSH_CHANNEL_NOTIFICATION(state, notification) {
			const disabled = false;
			if (!disabled) {
				state.channel_notifications[notification.channel] = notification.channel in state.channel_notifications ? state.channel_notifications[notification.channel] : {};
				state.channel_notifications[notification.channel][notification.identity] = true;
				localStorage.setItem('channel_notifications', JSON.stringify(state.channel_notifications));
				bus.$emit('update-render');
			}
		},
		//pop an notification from the channel, does not return the notification.
		POP_CHANNEL_NOTIFICATION(state, notification) {
			const disabled = false;
			if (!disabled) {
				state.channel_notifications[notification.channel] = notification.channel in state.channel_notifications ? state.channel_notifications[notification.channel] : {};
				Vue.delete(state.channel_notifications[notification.channel], notification.identity);
				// delete state.channel_notifications[notification.channel][notification.identity];
				localStorage.setItem('channel_notifications', JSON.stringify(state.channel_notifications));
				// bus.$emit("update-render");
			}
		},
		//store the payload avatar/image data.
		AVATAR_MODULE_CACHE_AVATAR(state, payload) {
			//used internally
			Vue.set(state.avatar_module.cache, payload.id, payload.avatar); //assignment
			state.avatar_module.cache[payload.id] = payload.avatar;
			Vue.delete(state.avatar_module.requested, payload.id);
			// delete state.avatar_module.requested[payload.id]; // remove from requested
			bus.$emit('update-render');
		},

		//begin requestnig an avatar/image to be asynchronously downloaded.
		//disabled
		AVATAR_MODULE_REQUESTING_AVATAR(state, id) {
			//used internally
			state.avatar_module.requested[id] = true;
			bus.$emit('update-render');
		},

		//push an API driven notification.
		// Will be automatically displayed in the notification slot of the dashboard.
		PUSH_NOTIFICATION(state, notification) {
			if (!('component' in notification) || !('data' in notification)) {
				console.error("pushed notification with bad payload. Expected [string] 'component'. [Object] 'data' . Got :", notification);
			} else {
				state.notifications.push(notification);
			}
			bus.$emit('update-render');
		},
		//remove the top most notification.
		POP_NOTIFICATION(state) {
			state.notifications.shift();
			bus.$emit('update-render');
		},
		//
		COMMIT_UPDATE_PRACTICE_LOCUM_SEARCH_DATES(state, payload) {
			state.practiceoffer.available_dates = payload;
		},
		//

		COMMIT_PRACTICE_REQUESTS_SENT(state, payload) {
			state.practiceRequestsSent.push(...payload);
		},

		COMMIT_PRACTICE_LOCUMS_APPLIED_TO(state, payload) {
			if (payload) {
				state.practiceLocumsAppliedTo.push(payload);
			} else {
				state.practiceLocumsAppliedTo = [];
			}
		},

		COMMIT_SUMMARY_TRACKED_AVAILABILITIES(state, payload) {
			state.summaryTrackedAvailabilities = payload;
		},

		SET_ADMIN_VIEW_LOCUM(state, payload) {
			if (state.adminViewingLocum == null) {
				state.adminViewingLocum = {};
			}

			for (const [key, value] of Object.entries(payload)) {
				Vue.set(state.adminViewingLocum, key, value); //assignment
			} //blanket assignment of all properties in payload to properties in state.adminViewingLocum;
		},

		SET_ADMIN_VIEW_PRACTICE(state, payload) {
			if (state.adminViewingPractice == null) {
				state.adminViewingPractice = {};
			}
			for (const key in payload) {
				if (key in payload) {
					const value = payload[key];
					Vue.set(state.adminViewingPractice, key, value); //assignment
				}
			} //blanket assignment of all properties in payload to properties in state.adminViewingPractice;
		},

		SET_PRACTICE_VIEWING_LOCUM(state, payload) {
			state.practiceViewingLocum = payload;
		},

		SET_PRACTICE_OFFER(state, payload) {
			state.practiceoffer = payload;
		},

		SET_PRACTICE_OFFER_SELECTED(state, payload) {
			state.practiceOfferSelected = payload;
		},

		SET_PRACTICE_APPLICATION_RECEIVED_SELECTED(state, payload) {
			state.practiceApplicationReceivedSelected = payload;
		},

		SET_PRACTICE_LOCUM_SEARCH_RESULTS(state, payload) {
			state.practiceLocumSearchResults = payload;
		},

		UPDATE_BROAD_LOCUM_RESULT_AVATAR(state, payload) {
			const data = payload.file;
			const locum_id = payload.id;
			const index = state.locumBroadSearch.Items.findIndex(locum => locum_id == locum.id);
			if (index > -1) {
				Vue.set(state.locumBroadSearch.Items[index], 'avatar', data);
			}
		},

		SET_PRACTICE_LOCUM_BROAD_SEARCH(state, payload) {
			state.locumBroadSearch = payload;
		},

		RESET_PRACTICE_LOCUM_SEARCH_RESULTS(state) {
			state.practiceLocumSearchResults = [];
			state.locumBroadSearch = [];
		},

		SET_LOCUM_AVAILABILITY_SELECTED(state, payload) {
			state.locumAvailabilitySelected = payload;
		},

		SET_LOCUM_VIEWING_PRACTICE(state, payload) {
			state.locumViewingPractice = payload;
		},

		SET_PRACTICE_LOCUM_AVAILABILITY_SLOT_SELECTED(state, payload) {
			state.practiceLocumAvailabilitySlotSelected = payload;
		},
		SET_LOCUM_PRACTICE_REQUEST_SELECTED(state, payload) {
			state.locumPracticeRequestSelected = payload;
		},

		SET_SELECTED_BOOKING(state, payload) {
			Vue.set(state, 'selectedBooking', payload);
		},

		SET_PRACTICE_BOOKING_REQUESTS_SENT(state, payload) {
			state.practiceBookingRequestsSent = payload;
			bus.$emit('update-render');
		},

		//
		SET_COGNITO_USERGROUPS(state, payload) {
			if (payload) {
				state.cognitoUserGroups = payload;
			}
		},

		PURGE_CALENDAR_EVENTS(state) {
			state.calendar_events = [];
		},
		ADD_CALENDAR_EVENT(state, payload) {
			state.calendar_events.push(payload);
		},
		SET_CAL_START_DATE(state, payload) {
			state.cal_start_date = payload;
		},
		SET_CAL_END_DATE(state, payload) {
			state.cal_end_date = payload;
		},

		ADD_AVAILABILITY(state, payload) {
			let payloadString = payload.date + '|' + payload.end_date + '|'; // + payload.start_time + "|" + payload.end_time + "|";
			const findIndex = state.availabilities.findIndex(
				existing =>
					('availability_code' in existing && 'availability_code' in payload && existing.availability_code == payload.availability_code) ||
					existing.date + '|' + existing.end_date + '|' == payloadString
			);
			if (findIndex > -1) {
				Vue.set(state.availabilities, findIndex, payload);
			} else {
				Vue.set(state.availabilities, state.availabilities.length, payload);
			}
		},

		DELETE_AVAILABILITY(state, payload) {
			let altered = state.availabilities.filter(existing => {
				let keep = true;
				if (payload.date == existing.date) {
					keep = false;
				}
				return keep;
			});
			state.availabilities = altered;
		},

		ADD_BOOKING(state, payload) {
			let findIndex = state.bookings.findIndex(existing => payload.unique_booking_code == existing.unique_booking_code);
			if (findIndex == -1) {
				Vue.set(state.bookings, state.bookings.length, payload);
			} else {
				Vue.set(state.bookings, findIndex, payload);
			}
		},

		ADD_OFFER(state, payload) {
			let payloadString = payload.id + '|' + payload.date + '|' + payload.end_date + '|'; // + payload.start_time + "|" + payload.end_time + "|";
			let findIndex = state.offers.findIndex(existing => existing.id + '|' + existing.date + '|' + existing.end_date + '|' == payloadString);
			if (findIndex == -1) {
				Vue.set(state.offers, state.offers.length, payload);
			} else {
				Vue.set(state.offers, findIndex, payload);
			}
		},

		DELETE_OFFER(state, payload) {
			let payloadString = payload.id + '|' + payload.date + '|' + payload.end_date + '|'; // + payload.start_time + "|" + payload.end_time + "|";
			let altered = state.offers.filter(existing => {
				let keep = true;
				if (payloadString == existing.id + '|' + existing.date + '|' + existing.end_date + '|') {
					keep = false;
				}
				return keep;
			});
			state.offers = altered;
		},

		SET_PROVINCES_REGIONS(state, payload) {
			state.provinces_regions = payload;
		},

		SET_PUBLIC_HOLIDAYS(state, payload) {
			state.public_holidays = payload;
		},

		SET_LEVELS(state, payload) {
			state.professionalSteps.levels = payload;
		},
		SET_LEVELS_COMPANY(state, payload) {
			state.companySteps.levels = payload;
		},

		SET_NEXT_STEP_REQUIRED(state, payload) {
			state.professionalSteps.nextRequiredStep = payload;
		},
		SET_NEXT_STEP_REQUIRED_COMPANY(state, payload) {
			state.companySteps.nextRequiredStep = payload;
		},

		SET_NEXT_STEP_BOOSTER(state, payload) {
			state.professionalSteps.nextBoosterStep = payload;
		},

		SET_STEP(state, payload) {
			bus.$emit('steps@refresh');
			state.professionalSteps.context = payload;
		},
		SET_STEP_COMPANY(state, payload) {
			bus.$emit('steps@refresh');
			state.companySteps.context = payload;
		},

		UPDATE_STEP(state, payload) {
			state.professionalSteps.required_forms.forEach(step => {
				if (step.context == payload.step) {
					step.status = payload.status;
				}
			});
			state.professionalSteps.booster_forms.forEach(step => {
				if (step.context == payload.step) {
					step.status = payload.status;
				}
			});
		},
		UPDATE_STEP_COMPANY(state, payload) {
			state.companySteps.required_forms.forEach(step => {
				if (step.context == payload.step) {
					step.status = payload.status;
				}
			});
		},

		SET_USER_SINGLE(state, { key, value }) {
			if (state.user == null) {
				state.user = {};
			}
			Vue.set(state.user, key, value); //assignment
		},
		SET_COMPANY_SINGLE(state, { key, value }) {
			if (state.company == null) {
				state.company = {};
			}
			Vue.set(state.company, key, value); //assignment
		},
		SET_COMPANY_OVERWRITE(state, overwrite) {
			state.company = overwrite; //overwrite assignment
		},
		ADD_COMPANY(state, company) {
			state.companies.push(company);
		},

		SET_USER_OVERWRITE(state, user) {
			state.user = { ...user };
		},

		SET_USER(state, payload) {
			if (state.user == null) {
				state.user = {};
			}
			for (const key in payload) {
				if (key in payload) {
					const value = payload[key];
					Vue.set(state.user, key, value); //assignment
				}
			} //blanket assignment of all properties in payload to properties in state.user;
		},

		SET_JWTTOKEN(state, payload) {
			state.jwtToken = payload;
		},

		SET_CONFIGS(state, payload) {
			let optionsPayload = payload;
			let configObj = {};
			let industryObj = {};
			let provinceObj = {};
			let languagesList = [];

			configObj.industries = industryObj;
			configObj.provinces = provinceObj;

			for (const option of optionsPayload) {
				// Insert industry name and profession into industryObj
				if (option.subs?.SS) {
					industryObj[option.name] = option.subs.SS;

					// Insert province name and regions into provinceObj
				} else if (option?.subs) {
					provinceObj[option.name] = option.subs;
				} else if (option.category === 'languages') {
					if (!option.isdeleted) {
						const { name, order } = option;
						languagesList.push({ name, order });
					}
					// Insert languages, booking-status and booking-cancellation-reason into configObj
				} else {
					if (Object.keys(configObj).includes(option.category)) {
						configObj[option.category].push(option.name);
					} else {
						configObj[option.category] = [option.name];
					}
				}
			}

			languagesList.sort((a, b) => {
				a.order - b.order;
			});

			configObj.languages = languagesList.map(l => l.name);
			state.configs = { ...state.configs, ...configObj };
		},

		SET_INDUSTRIES(state, payload) {
			let industriesV2 = {};
			for (const option of payload) {
				industriesV2[option.name] = option;
			}
			state.configs = { ...state.configs, industriesV2 };
		},

		SET_INDUSTRY_KEYS(state, payload) {
			let industryKeys = {};
			for (const option of payload) {
				if (option.professions) {
					for (const { skills } of option.professions) {
						if (skills) {
							for (const { name: skillName, options, code: skillCode } of skills) {
								if (options) {
									for (const { name: optionName, code: optionCode } of options) {
										industryKeys[optionCode] = `${skillName} ${optionName}`;
									}
								} else {
									industryKeys[skillCode] = `${skillName}`;
								}
							}
						}
					}
				}
			}
			state.configs = { ...state.configs, industryKeys };
		},

		SET_COMPANY(state, payload) {
			if (state.company == null) {
				state.company = {};
			}

			Object.assign(state.company, payload);

			bus.$emit('PracticeCalendarUpdated');
			bus.$emit('update-render');
		},
		SET_COMPANIES(state, payload) {
			state.companies = payload;
		},

		SET_TEST(state, payload) {
			state.test = payload;
		},

		SET_PRACTICE_LOCUM_SEARCH_RESULT_AVATAR(state, payload) {
			const data = payload.file;
			const locum_id = payload.id;

			const copy = state.practiceLocumSearchResults[locum_id].slice();
			state.practiceLocumSearchResults[locum_id].forEach((availability, index) => {
				copy[index].avatar = data;
			});
			Vue.set(state.practiceLocumSearchResults, locum_id, copy);
		},

		SET_PRACTICE_LOCUM_SEARCH_RESULT_PROFILE(state, payload) {
			const profile = payload.profile;
			const locum_id = payload.id;
			const copy = state.practiceLocumSearchResults[locum_id].slice();
			state.practiceLocumSearchResults[locum_id].forEach((availability, index) => {
				for (const key in profile) {
					if (key in profile) {
						const value = profile[key];
						Vue.set(copy[index], key, value); //assignment
					}
				}
				let years_experience = moment().diff(copy[index].experience.start_date, 'years', false);
				copy[index].experience.years_experience = years_experience;
			});
			Vue.set(state.practiceLocumSearchResults, locum_id, copy);
		},

		ADD_BOOKING_REQUEST(state, payload) {
			if (payload.request.status == 'cancelled') {
				return;
			}
			let request = payload.request;
			let sourceIsAvailability = 'availability' in payload;
			if (sourceIsAvailability) {
				let availability_start_date = payload.availability_start_date;
				let index = state.booking_requests.findIndex(
					set => 'availability' in set && set.availability_start_date == availability_start_date && set.request.id == request.id
				);
				if (index > -1) {
					Vue.set(state.booking_requests, index, payload);
				} else {
					state.booking_requests.push(payload);
				}
			} else {
				let offer_start_date = payload.offer_start_date;
				let index = state.booking_requests.findIndex(set => {
					let test = 'offer' in set && set.offer_start_date == offer_start_date && set.request.id == request.id;
					return test;
				});

				if (index > -1) {
					Vue.set(state.booking_requests, index, payload);
				} else {
					state.booking_requests.push(payload);
				}
			}
		},

		REMOVE_BOOKING_REQUEST(state, payload) {
			let request = payload.request;
			let sourceIsAvailability = 'availability' in payload;
			if (sourceIsAvailability) {
				let availability_start_date = payload.availability_start_date;
				let index = state.booking_requests.findIndex(
					set => 'availability' in set && set.availability_start_date == availability_start_date && set.request.id == request.id
				);

				if (index > -1) {
					Vue.delete(state.booking_requests, index);
				}
			} else {
				let offer_start_date = payload.offer_start_date;
				let index = state.booking_requests.findIndex(set => {
					let test = 'offer' in set && set.offer_start_date == offer_start_date && set.request.id == request.id;
					return test;
				});

				if (index > -1) {
					Vue.delete(state.booking_requests, index);
				}
			}
		},

		ADD_PRIVATE_BOOKING_REQUEST(state, payload) {
			if (payload.request.status == 'cancelled') {
				return;
			}
			let id = payload.offer.id;
			let index = state.booking_requests.findIndex(set => ('availability' in set ? set.request : set.offer).id == id);
			if (index > -1) {
				Vue.set(state.booking_requests, index, payload);
			} else {
				state.booking_requests.push(payload);
			}
		},
		REMOVE_PRIVATE_BOOKING_REQUEST(state, payload) {
			let id = payload.offer.id;
			let index = state.booking_requests.findIndex(set => ('availability' in set ? set.request : set.offer).id == id);
			if (index > -1) {
				Vue.delete(state.booking_requests, index);
			}
		},
	},
	actions: {
		async SET_LAST_ACTIVE_LOCUM(context) {
			try {
				const token = context.getters.jwtToken;
				await axios.post(`${context.getters.getAPI}/professionals/updateLastActive/${context.getters.user.id}`, { headers: { Authorization: token } });
			} catch (err) {
				console.error("Failed to set Locum's last active timestamp", err);
			}
		},
		async GET_CONFIGS_FROM_API(context) {
			const token = context.getters.jwtToken;
			try {
				let response = await axios.get(context.getters.getAPI + '/options', { headers: { Authorization: token } });
				context.commit('SET_CONFIGS', response.data.data.Items);
			} catch (err) {
				console.error('Error getting configs from API', err);
			}
		},
		async GET_INDUSTRIES_FROM_API({ getters, commit }, tenantId) {
			const token = getters.jwtToken;
			if (!tenantId) {
				tenantId = getters.company ? getters.company.tenantId : getters.user.tenantId;
			}

			try {
				let response = await axios.get(getters.getAPI + `/options/industries/${tenantId}`, { headers: { Authorization: token } });
				commit('SET_INDUSTRIES', response.data);
				commit('SET_INDUSTRY_KEYS', response.data);
			} catch (err) {
				console.error('Error getting industries from API', err);
			}
		},
		async UPDATE_AVAILABILITY(context, payload) {
			context.commit('ADD_AVAILABILITY', payload);
			if ('booking_requests' in payload) {
				payload.booking_requests
					.map(request => ({ request: request, availability_start_date: payload.date, availability: payload }))
					.forEach(set => {
						context.commit('ADD_BOOKING_REQUEST', set);
					});
			}
		},
		async UPDATE_OFFER(context, payload) {
			await context.commit('ADD_OFFER', payload);
			let offer = payload;

			if ('offer_type' in offer && offer.offer_type == 'private') {
				//addition
				if ('offers_requests' in offer) {
					offer.offers_requests
						.map(request => ({ request: request, offer_start_date: offer.date, offer: offer }))
						.forEach(set => {
							context.commit('ADD_PRIVATE_BOOKING_REQUEST', set);
						});
				}
			} else {
				if ('offers_requests' in offer) {
					offer.offers_requests.forEach(request => {
						context.commit('ADD_BOOKING_REQUEST', { request: request, offer_start_date: offer.date, offer: offer });
					});
				}
			}
		},
		async AVATAR_MODULE_REQUEST_AVATAR(context, id) {
			context.commit('AVATAR_MODULE_REQUESTING_AVATAR', id);
			const token = context.getters.jwtToken;
			const header = { headers: { Authorization: token } };
			axios
				.get(context.getters.getDOCUMENTS + '/images/avatar/' + id, header)
				.then(response => {
					context.commit('AVATAR_MODULE_CACHE_AVATAR', { id: id, avatar: 'data:image/png;base64,' + response.data.data });
				})
				.catch(() => {
					context.commit('AVATAR_MODULE_CACHE_AVATAR', { id: id, avatar: 'no-avatar' });
				});
		},

		async GET_USER_AVATAR(context) {
			//context, payload
			//fetch this users avatar IF its set. assigns to user store avatar_file the src
			if ('avatar_file' in context.getters.user) {
				return context.getters.user.avatar_file;
			} else if (
				'documents' in context.getters.user &&
				'images' in context.getters.user.documents &&
				context.getters.user.documents.images.findIndex(val => val == 'avatar') > -1
			) {
				const token = context.getters.jwtToken;
				const header = { headers: { Authorization: token } };
				axios.get(context.getters.getDOCUMENTS + '/images/avatar/' + context.getters.user.id, header).then(response => {
					context.commit('SET_USER', { avatar_file: 'data:image/png;base64,' + response.data.data });
					return 'data:image/png;base64,' + response.data.data;
				});
			} else {
				return null;
			}
		},
		async GET_PRACTICE_LOGO(context) {
			//fetch this practice's logo - IF its specified.
			if ('logo_file' in context.getters.company) {
				return context.getters.company.logo_file;
			} else if (
				'documents' in context.getters.company &&
				'images' in context.getters.company.documents &&
				context.getters.company.documents.images.findIndex(val => val == 'logo') > -1
			) {
				const token = context.getters.jwtToken;
				const header = { headers: { Authorization: token } };
				axios.get(context.getters.getDOCUMENTS + '/images/logo/' + context.getters.company.id, header).then(response => {
					context.commit('SET_COMPANY', { logo_file: 'data:image/png;base64,' + response.data.data });
					return 'data:image/png;base64,' + response.data.data;
				});
			} else {
				return null;
			}
		},
		async GET_OTHER_PRACTICE_LOGO(context, payload) {
			if (payload) {
				const token = context.getters.jwtToken;
				const header = { headers: { Authorization: token } };
				const company = await axios.get(context.getters.getAPI + '/companies/' + payload, header);

				if (company.status == 200) {
					if ('documents' in company.data.data && 'images' in company.data.data.documents && company.data.data.documents.images.findIndex(val => val == 'logo') > -1) {
						const logo = await axios.get(context.getters.getDOCUMENTS + '/images/logo/' + company.data.data.id, header);

						if (logo.status == 200) {
							return 'data:image/png;base64,' + logo.data.data;
						} else {
							return null;
						}
					} else {
						return null;
					}
				}
			}
		},

		async PERFORM_LOCUM_SEARCH_SPECIFIC(context, payload) {
			context.commit('RESET_PRACTICE_LOCUM_SEARCH_RESULTS');

			const criteria_locumprofession = payload.profession;
			const criteria_startDate = payload.startDate;
			const criteria_endDate = payload.endDate;

			const token = context.getters.jwtToken;

			const response = await axios.get(
				context.getters.getAPI + '/calendar/professional/availability/search/' + criteria_locumprofession + '/' + criteria_startDate + '/' + criteria_endDate,
				{ headers: { Authorization: token } }
			);

			let all_search_results = [];

			all_search_results.push(...response.data.data.Items);

			let all_search_results_unique = [];
			//we need only unique items so make sure of that,
			all_search_results.forEach(result => {
				if (!all_search_results_unique.find(item => item.id == result.id && item.date == result.date)) {
					all_search_results_unique.push(result);
				}
			});

			context.dispatch('setPracticeLocumSearchResults', all_search_results_unique);
			return all_search_results_unique;
		},

		async PERFORM_LOCUM_SEARCH({ commit, getters, dispatch }, payload) {
			commit('RESET_PRACTICE_LOCUM_SEARCH_RESULTS');
			const criteria_profession = payload.profession;
			let token = getters.jwtToken;
			let exact_matches = [];

			const params = queryString.stringify({
				languages: payload.languages,
				location: payload.location,
				rates: payload.rates,
				experience: payload.experience,
				searchDates: payload.dates,
				skills: payload.skills,
			});

			try {
				const { data } = await axios.get(`${getters.getAPI}/calendar/professional/availability/search-v2/${criteria_profession}/${getters.company.id}?${params}`, {
					headers: { Authorization: token },
				});
				if (data && data.length > 0) {
					exact_matches = data;
				}
			} catch (error) {
				console.error('Error fetching exact locum results: ', error);
			}

			const broadSearch = await axios.get(`${getters.getAPI}/professionals/search/${criteria_profession}?${params}`, { headers: { Authorization: token } });

			const { Items, Count } = broadSearch.data.data;
			const addedLocums = [];

			const filteredBroadSearch = Items.filter(({ id: searchId, willing_to_travel, locations }) => {
				if (willing_to_travel && !locations.includes(payload.location)) return false; //[INFO]: Temporarily exclude willing to travel locums, while location functionality is fully implemeneted
				if (!addedLocums.includes(searchId)) {
					addedLocums.push(searchId);
					return !exact_matches.some(({ id }) => id === searchId);
				}
			});
			commit('SET_PRACTICE_LOCUM_BROAD_SEARCH', { Items: filteredBroadSearch, Count });

			dispatch('setPracticeLocumSearchResults', exact_matches);
			return exact_matches;
		},

		async PERFORM_LOCUM_SEARCH_DATES({ commit, getters, dispatch }, payload) {
			commit('RESET_PRACTICE_LOCUM_SEARCH_RESULTS');
			const professions = payload.professions;
			const criteria_profession = payload.profession;
			let token = getters.jwtToken;
			let exact_matches = [];

			const params = queryString.stringify({
				// location: payload.location,
				// searchDates: payload.dates,
			});

			try {
				const { data } = await axios.get(`${getters.getAPI}/calendar/professional/availability/search-v2/${criteria_profession}/${getters.company.id}?${params}`, {
					headers: { Authorization: token },
				});
				if (data && data.length > 0) {
					exact_matches = data;
				}
			} catch (error) {
				console.error('Error fetching exact locum results: ', error);
			}

			const requests = professions.map(profession => axios.get(getters.getAPI + '/professionals/search/' + profession + '?' + params, { headers: { Authorization: token } }));

			let responses;
			try {
				responses = await Promise.all(
					requests.map(async request => {
						try {
							return await request;
						} catch (error) {
							// Handle individual request error
							console.error('Error in one of the requests:', error);
							return null;
						}
					})
				);

				// Filter out null responses (responses from failed requests)
				let successfulResponses = responses.filter(response => response !== null);
				responses = successfulResponses;
			} catch (error) {
				console.error('Error during requests:', error);
			}

			let filteredBroadSearch = [];
			let totalCount = 0;

			responses.map(response => {
				const { Items, Count } = response.data.data;
				const addedLocums = [];

				const filteredItems = Items.filter(({ id: searchId, willing_to_travel, locations }) => {
					if (willing_to_travel && !locations.includes(payload.location)) return false; //[INFO]: Temporarily exclude willing to travel locums, while location functionality is fully implemeneted
					if (!addedLocums.includes(searchId)) {
						addedLocums.push(searchId);
						return !exact_matches.some(({ id }) => id === searchId);
					}
				});
				totalCount = totalCount + Count;
				filteredBroadSearch = filteredBroadSearch.concat(filteredItems);
			});
			commit('SET_PRACTICE_LOCUM_BROAD_SEARCH', { Items: filteredBroadSearch, totalCount });

			dispatch('setPracticeLocumSearchResults', exact_matches);
			return exact_matches;
		},

		async SET_PRACTICE_REQUESTS_SENT(context, payload) {
			context.commit('COMMIT_PRACTICE_REQUESTS_SENT', payload);
		},

		SET_PRACTICE_LOCUMS_APPLIED_TO(context, payload) {
			context.commit('COMMIT_PRACTICE_LOCUMS_APPLIED_TO', payload);
		},

		SET_SUMMARY_TRACKED_AVAILABILITIES(context, payload) {
			context.commit('COMMIT_SUMMARY_TRACKED_AVAILABILITIES', payload);
		},
		//
		setLocumAvailabilitySelected(context, payload) {
			context.commit('SET_LOCUM_AVAILABILITY_SELECTED', payload);
		},

		setLocumViewingPractice(context, payload) {
			context.commit('SET_LOCUM_VIEWING_PRACTICE', payload);
		},

		async setLocumPracticeRequestSelected(context, payload) {
			await context.commit('SET_LOCUM_PRACTICE_REQUEST_SELECTED', payload);
		},

		setAdminViewingLocum(context, payload) {
			context.commit('SET_ADMIN_VIEW_LOCUM', payload);
		},
		setAdminViewingPractice(context, payload) {
			context.commit('SET_ADMIN_VIEW_PRACTICE', payload);
		},

		setPracticeViewingLocum(context, payload) {
			context.commit('SET_PRACTICE_VIEWING_LOCUM', payload);
		},

		setPracticeOffer(context, payload) {
			context.commit('SET_PRACTICE_OFFER', payload);
		},

		setPracticeOfferSelected(context, payload) {
			context.commit('SET_PRACTICE_OFFER_SELECTED', payload);
		},

		setPracticeApplicationReceivedSelected(context, payload) {
			context.commit('SET_PRACTICE_APPLICATION_RECEIVED_SELECTED', payload);
		},

		setPracticeLocumSearchResults(context, payload) {
			context.commit('SET_PRACTICE_LOCUM_SEARCH_RESULTS', payload);
		},

		setPracticeLocumAvailabilitySlotSelected(context, payload) {
			context.commit('SET_PRACTICE_LOCUM_AVAILABILITY_SLOT_SELECTED', payload);
		},

		setPracticeBookingRequestsSent(context, payload) {
			context.commit('SET_PRACTICE_BOOKING_REQUESTS_SENT', payload);
		},

		UPDATE_LOCUM_RESULT_PROFILE(context, payload) {
			context.commit('SET_PRACTICE_LOCUM_SEARCH_RESULT_PROFILE', payload);
		},

		UPDATE_LOCUM_RESULT_AVATAR(context, payload) {
			context.commit('SET_PRACTICE_LOCUM_SEARCH_RESULT_AVATAR', payload);
		},

		UPDATE_BROAD_LOCUM_RESULT_AVATAR(context, payload) {
			context.commit('UPDATE_BROAD_LOCUM_RESULT_AVATAR', payload);
		},

		initCompanies(context, companies) {
			if (companies.length > 0) {
				context.commit('SET_COMPANIES', companies);
				context.commit('SET_COMPANY', companies[0]);
			} else {
				context.commit('SET_COMPANIES', []);
				context.commit('SET_COMPANY', null);
			}
		},

		// eslint-disable-next-line
		IsInGroup(context, group) {
			return context.getters.getCognitoUserGroups.includes(group);
		},

		async manageCompany(context, companyID) {
			let companies = context.getters.companies;
			let company = companies.find(company => company.id === companyID);
			if (company) {
				context.commit('SET_COMPANY_OVERWRITE', company);
				return true;
			}
			return false;
		},

		async SetCalendarDateRange(context, DateRange) {
			await context.commit('SET_CAL_START_DATE', DateRange.start);
			await context.commit('SET_CAL_END_DATE', DateRange.end);
		},

		//This method serves to on demand grab the calendar data between the two dates, or from the first of the current month to end of current month.
		//The result is stored in state availabilties.
		//would also update all booking requests.
		//would also update all confirmed bookings etc.
		//best to await this method for strict control.
		// eslint-disable-next-line
		async LocumUpdateCalendar(context, payload) {
			//recoded to instead break up the various groupings into their own fetch code (even if overlaps occur)
			//see following methods.
		},

		async LocumUpdateAvailabilities(context, payload) {
			const startdate = payload[1];
			const enddate = payload[2];

			const token = context.getters.jwtToken;
			const startDate = (startdate ? moment(startdate) : moment()).startOf('month');
			const endDate = (enddate ? moment(enddate) : moment()).endOf('month');
			let response = await axios.get(context.getters.getAPI + '/calendar/professional/availability/' + startDate.format('YYYY-MM-DD') + '/' + endDate.format('YYYY-MM-DD'), {
				headers: { Authorization: token },
			});
			if (response.status == 200) {
				response.data.data.Items.forEach(availability => {
					context.commit('ADD_AVAILABILITY', availability);
				});
			}
			if ('suppressUpdate' in payload) {
				return;
			}
			bus.$emit('LocumCalendarUpdated');
			bus.$emit('update-render');
		},

		async LocumUpdateBookings(context, payload) {
			const startdate = payload[1];
			const enddate = payload[2];
			const token = context.getters.jwtToken;
			const startDate = (startdate ? moment(startdate) : moment()).startOf('month');
			const endDate = (enddate ? moment(enddate) : moment()).endOf('month');

			const bookings = await axios.get(
				context.getters.getAPI + '/bookings/professional/' + context.getters.user.id + '/' + startDate.format('YYYY-MM-DD') + '/' + endDate.format('YYYY-MM-DD'),
				{ headers: { Authorization: token } }
			);

			bookings.data.data.Items.forEach(booking => {
				context.commit('ADD_BOOKING', booking);
			});
			if ('suppressUpdate' in payload) {
				return;
			}
			bus.$emit('LocumCalendarUpdated');
			bus.$emit('update-render');
		},

		async LocumUpdateOffers(context, payload) {
			const startdate = payload[1];
			const enddate = payload[2];
			const token = context.getters.jwtToken;
			const startDate = (startdate ? moment(startdate) : moment()).startOf('month');
			const endDate = (enddate ? moment(enddate) : moment()).endOf('month');

			let response = await axios.get(
				context.getters.getAPI +
					'/offers/company/search/' +
					context.getters.user.profession +
					'/' +
					startDate.format('YYYY-MM-DD') +
					'/' +
					endDate.format('YYYY-MM-DD') +
					'/0',
				{ headers: { Authorization: token } }
			);
			if (response.status == 200) {
				response.data.data.Items.forEach(offer => {
					context.commit('ADD_OFFER', offer);
				});
			}
			if ('suppressUpdate' in payload) {
				return;
			}
			bus.$emit('LocumCalendarUpdated');
			bus.$emit('update-render');
		},

		async LocumUpdateApplicationsSent(context, payload) {
			payload.suppressUpdate = true;
			await context.dispatch('LocumUpdateOffers', payload);
			delete payload.suppressUpdate;

			context.getters.getOffers.forEach(offer => {
				if ('offer_type' in offer && offer.offer_type == 'private') {
					//addition
					offer.offers_requests
						.map(request => (request.id == context.getters.user.id ? { request: request, offer_start_date: offer.date, offer: offer } : false))
						.forEach(set => {
							if (set && set.request.status == 'requested') {
								context.commit('ADD_PRIVATE_BOOKING_REQUEST', set);
							}
						});
				} else {
					if ('offers_requests' in offer) {
						let offers_requests_by_me = offer.offers_requests.filter(request => request.id == context.getters.user.id && request.status == 'requested');
						if (offers_requests_by_me.length > 0) {
							offers_requests_by_me
								.map(request => ({ request: request, offer_start_date: offer.date, offer: offer }))
								.forEach(set => {
									context.commit('ADD_BOOKING_REQUEST', set);
								});
						}
					}
				}
			});
			if ('suppressUpdate' in payload) {
				return;
			}
			bus.$emit('LocumCalendarUpdated');
			bus.$emit('update-render');
		},

		async LocumUpdateRequestsReceived(context, payload) {
			payload.suppressUpdate = true;
			await context.dispatch('LocumUpdateApplicationsSent', payload);
			await context.dispatch('LocumUpdateAvailabilities', payload);
			delete payload.suppressUpdate;

			const getAvailabilities = context.getters.getRequestedAvailabilities;

			getAvailabilities
				.filter(availability => 'booking_requests' in availability)
				.forEach(availability => {
					if ('booking_requests' in availability) {
						availability.booking_requests
							.map(request => ({ request: request, availability_start_date: availability.date, availability: availability }))
							.forEach(set => {
								context.commit('ADD_BOOKING_REQUEST', set);
							});
					}
				});
			if ('suppressUpdate' in payload) {
				return;
			}
			bus.$emit('LocumCalendarUpdated');
			bus.$emit('update-render');
		},

		//////////////////////////////// PRACTICE ////////////////////////////////

		async PracticeUpdateBookings(context, payload) {
			const startdate = payload[1];
			const enddate = payload[2];
			const token = context.getters.jwtToken;

			const startDate = (startdate ? moment(startdate) : moment()).startOf('month');
			const endDate = (enddate ? moment(enddate) : moment()).endOf('month');

			try {
				const bookings = await axios.get(
					context.getters.getAPI + '/bookings/practice/' + context.getters.company.id + '/' + startDate.format('YYYY-MM-DD') + '/' + endDate.format('YYYY-MM-DD'),
					{ headers: { Authorization: token } }
				);

				bookings.data.data.Items.forEach(booking => {
					context.commit('ADD_BOOKING', booking);
				});
			} catch (err) {
				console.error(err);
			}

			if ('suppressUpdate' in payload) {
				return;
			}
			bus.$emit('PracticeCalendarUpdated');
			bus.$emit('update-render');
		},

		async PracticeUpdateOffers(context, payload) {
			const startdate = payload[1];
			const enddate = payload[2];

			const token = context.getters.jwtToken;
			const startDate = (startdate ? moment(startdate) : moment()).startOf('month');
			const endDate = (enddate ? moment(enddate) : moment()).endOf('month');

			let response = await axios.get(
				context.getters.getAPI + '/offers/company/' + context.getters.company.id + '/' + startDate.format('YYYY-MM-DD') + '/' + endDate.format('YYYY-MM-DD'),
				{ headers: { Authorization: token } }
			);
			if (response.status == 200) {
				response.data.data.Items.forEach(offer => {
					context.commit('ADD_OFFER', offer);
				});
			}
			if ('suppressUpdate' in payload) {
				return;
			}
			bus.$emit('PracticeCalendarUpdated');
			bus.$emit('update-render');
		},

		async PracticeUpdateLocumApplications(context, payload) {
			payload.suppressUpdate = true;
			await context.dispatch('PracticeUpdateOffers', payload); //dependency - coupled to offers.
			delete payload.suppressUpdate;
			const offers = context.getters.getOffers;

			offers.forEach(offer => {
				if ('offer_type' in offer && offer.offer_type == 'private') {
					//addition
					if ('offers_requests' in offer) {
						offer.offers_requests
							.map(request => ({ request: request, offer_start_date: offer.date, offer: offer }))
							.forEach(set => {
								context.commit('ADD_PRIVATE_BOOKING_REQUEST', set);
							});
					}
				} else {
					if ('offers_requests' in offer) {
						offer.offers_requests.forEach(request => {
							context.commit('ADD_BOOKING_REQUEST', { request: request, offer_start_date: offer.date, offer: offer });
						});
					}
				}
			});
			if ('suppressUpdate' in payload) {
				return;
			}
			bus.$emit('PracticeCalendarUpdated');
			bus.$emit('update-render');
		},

		async PracticeUpdateBookingRequests(context, payload) {
			payload.suppressUpdate = true;
			await context.dispatch('PracticeUpdateLocumApplications', payload); //updates BReq based on offers (priv BReq)
			delete payload.suppressUpdate;
			// let debug = true
			const startdate = payload[1];
			const enddate = payload[2];

			const token = context.getters.jwtToken;
			const startDate = (startdate ? moment(startdate) : moment()).startOf('month');
			const endDate = (enddate ? moment(enddate) : moment()).endOf('month');

			let expertises = [];
			// For Pharmacy practices, locums required include Pharmacy & Nursing professions
			let nursingProfessions = [];
			if (context.getters.user.industry === 'Pharmacy') {
				nursingProfessions = context.getters.configs.industries['Nursing'];
			}
			// For all other practices, locum professions required from relevant industry
			let professionOptions = context.getters.configs.industries[context.getters.user.industry];

			const professions = nursingProfessions.concat(professionOptions);

			professions.forEach(expertise =>
				expertises.push(
					axios.get(
						context.getters.getAPI +
							'/calendar/professional/availability/search/' +
							expertise +
							'/' +
							startDate.format('YYYY-MM-DD') +
							'/' +
							endDate.format('YYYY-MM-DD'),
						{ headers: { Authorization: token } }
					)
				)
			);

			let responses = await axios.all(expertises);
			responses
				.filter(response => response.status == 200)
				.forEach(response => {
					let data = response.data.data.Items;
					data.filter(avail => 'booking_requests' in avail && avail.booking_requests.some(req => req.id == context.getters.company.id)).forEach(avail => {
						avail.booking_requests.forEach(req => {
							if (req.id == context.getters.company.id) {
								context.commit('ADD_BOOKING_REQUEST', { request: req, availability_start_date: avail.date, availability: avail });
							}
						});
					});
				});
			if ('suppressUpdate' in payload) {
				return;
			}
			bus.$emit('PracticeCalendarUpdated');
			bus.$emit('update-render');
		},

		//This method serves to on demand grab the calendar data between the two dates, or from the first of the current month to end of current month.
		//The result is stored in state availabilties.
		//would also update all booking requests.
		//would also update all confirmed bookings etc.
		//best to await this method for strict control.
		async PracticeUpdateCalendar(context, payload) {
			payload.suppressUpdate = true; //suppress updates to visuals, else we would update visuals each PracticeUpdate*** call
			await context.dispatch('PracticeUpdateBookings', payload);
			// await context.dispatch("PracticeUpdateOffers",payload)
			await context.dispatch('PracticeUpdateLocumApplications', payload);
			delete payload.suppressUpdate; // dont suppress this last update, so that the visuals are updated.
			await context.dispatch('PracticeUpdateBookingRequests', payload);
			// bus.$emit("PracticeCalendarUpdated");
		},

		async UpdateCalendarEvents(context) {
			//This method has not been touched since v3 launch, the big visual calendar does not actually work.
			await context.commit('PURGE_CALENDAR_EVENTS');
			// let all_availabilites = await context.dispatch("UpdateAvailabilities","[context.action] UpdateCalendar");
			let all_availabilites = context.getters.getAvailabilities;

			console.error('all avaialbilities prior to loop', all_availabilites);
			all_availabilites.forEach(availability => {
				console.error('availability used to make event being sent to BIG calendar', availability);
				console.error(
					'test -> date , end_date, start-time, end-time of availability',
					availability.date,
					availability.end_date,
					availability.start_time,
					availability.end_time
				);
				context.commit('ADD_CALENDAR_EVENT', {
					name: availability.status == 'unavailable' ? 'Unavailable' : 'Available',
					start: availability.date + ' ' + availability.start_time,
					end: availability.end_date ? availability.end_date : availability.date + ' ' + availability.end_time,
					color: availability.status == 'available' ? 'secondary' : 'red',
					type: availability.status,
				});
			});

			(this.name = ''), (this.start = ''), (this.end = ''), (this.color = ''), (this.type = '');

			// eslint-disable-next-line vue/no-side-effects-in-computed-properties
			return context.getters.getAllCalendarEvents;
		},

		// TODO: Remove this action when updating with configs.provinces
		async UpdateProvincesRegions(context) {
			const token = context.getters.jwtToken;
			let response = await axios.get(context.getters.getAPI + '/options/category/provinces', { headers: { Authorization: token } });
			if (response.status == 200) {
				context.commit('SET_PROVINCES_REGIONS', response.data.data);
			} else {
				context.commit('SET_PROVINCES_REGIONS', []);
			}
			return context.getters.getProvinceRegions;
		},

		async UpdatePublicHolidays(context) {
			const token = context.getters.jwtToken;
			let response = await axios.get(context.getters.getAPI + '/options/category/public-holidays', { headers: { Authorization: token } });
			if (response.status == 200) {
				if (response.data.data && response.data.data.Items[0] && response.data.data.Items[0].subs) {
					context.commit('SET_PUBLIC_HOLIDAYS', response.data.data.Items[0].subs);
				}
			} else {
				context.commit('SET_PUBLIC_HOLIDAYS', []);
			}
			return context.getters.getPublicHolidays;
		},

		UPDATE_NEXT_SIGNUP_STEP(context) {
			//uses duck test to call the checkStep method on each step component passing in the user.
			//if a step returns false the it is incomplete else true is complete.
			let out = false;
			context.getters.stepsRequired.forEach(step => {
				if (step.context == 'create-account-step') {
					context.commit('UPDATE_STEP', { step: step.context, status: true });
				}
				if (step.form) {
					//nifty implementation to call the checkStep method inside the component. This way each component self contains the duck test
					//this test should compare the state of the users profile against whatever criteria the step wants, returning TRUE or FALSE - declaring compelte or now.
					let result = step.form.methods.checkStep.call(step.form.data(), context.getters.user); //true or false was the step complete
					context.commit('UPDATE_STEP', { step: step.context, status: result });
					if (context.getters.currentStep != step.context && !result && !out) {
						//the first step to fail its test is 'out', and marked as the next step in users journey.
						out = step;
					}
				}
			});
			context.commit('SET_NEXT_STEP_REQUIRED', out);

			out = false;
			context.getters.stepsBoosted.forEach(step => {
				if (step.form) {
					let result = step.form.methods.checkStep.call(step.form.data(), context.getters.user);
					context.commit('UPDATE_STEP', { step: step.context, status: result });
					if (context.getters.currentStep != step.context && !result && !out) {
						out = step;
					}
				}
			});
			context.commit('SET_NEXT_STEP_BOOSTER', out);
		},

		UPDATE_NEXT_SIGNUP_STEP_COMPANY(context) {
			let out = false;

			context.getters.stepsRequiredCompany.forEach(step => {
				if (step.context == 'create-account-step') {
					context.commit('UPDATE_STEP_COMPANY', { step: step.context, status: true });
				}
				if (step.form) {
					let result = step.form.methods.checkStep.call(step.form.data(), context.getters.user); //true or false was the step complete
					context.commit('UPDATE_STEP_COMPANY', { step: step.context, status: result });

					if (context.getters.currentStepCompany != step.context && !result && !out) {
						out = step;
					}
				}
			});
			context.commit('SET_NEXT_STEP_REQUIRED_COMPANY', out); //Sets the next Sign up step
		},
	},
	getters: {
		getAPI() {
			return process.env.VUE_APP_APIURL;
		},
		getAUTH() {
			return process.env.VUE_APP_AUTHURL;
		},
		getAPP() {
			return process.env.VUE_APP_APPURL;
		},
		getDOCUMENTS() {
			return process.env.VUE_APP_DOCUMENTURL;
		},
		getChannelCount: state => channel => Object.keys(channel in state.channel_notifications ? state.channel_notifications[channel] : {}).length,
		noAvatar(state) {
			return state.avatar_module.no_avatar;
		},
		currentRoute(state) {
			return state.currentRoute;
		},
		adminLastSearch(state) {
			return state.adminLastSearch;
		},
		getCachedAvatar: state => id => {
			//pass id as argument
			if (state.avatar_module.cache[id]) {
				return state.avatar_module.cache[id];
			} else {
				if (!(id in state.avatar_module.requested)) {
					// not yet requested - request it
					store.dispatch('AVATAR_MODULE_REQUEST_AVATAR', id);
					return false;
				}
			}
		},

		getLocumBroadSearch({ locumBroadSearch, practiceLocumsAppliedTo }) {
			let Count = locumBroadSearch.Count;
			let Items = locumBroadSearch.Items;
			if (practiceLocumsAppliedTo) {
				Items = Items.filter(locum => !practiceLocumsAppliedTo.includes(locum.id));
				Count = Items.length;
			}
			return { Count, Items };
		},
		getNotifications(state) {
			return state.notifications;
		},
		getPracticeRequestsSent(state) {
			return state.practiceRequestsSent;
		},
		getPracticeLocumsAppliedTo(state) {
			return state.practiceLocumsAppliedTo;
		},
		getSummaryTrackedAvailabilities(state) {
			return state.summaryTrackedAvailabilities;
		},

		getPracticeOfferSelected(state) {
			return state.practiceOfferSelected;
		},

		getPracticeViewingLocum(state) {
			return state.practiceViewingLocum;
		},
		getAdminViewingLocum(state) {
			return state.adminViewingLocum;
		},
		getAdminViewingPractice(state) {
			return state.adminViewingPractice;
		},

		getPracticeOffer(state) {
			return state.practiceoffer;
		},

		getPracticeLocumSearchResults({ practiceLocumSearchResults, practiceLocumsAppliedTo }) {
			let searchResults = practiceLocumSearchResults;
			if (practiceLocumsAppliedTo) {
				searchResults = searchResults.filter(locum => !practiceLocumsAppliedTo.includes(locum.id));
			}
			return searchResults;
		},

		getPracticeLocumAvailabilitySlotSelected(state) {
			return state.practiceLocumAvailabilitySlotSelected;
		},

		getLocumAvailabilitySelected(state) {
			return state.locumAvailabilitySelected;
		},

		getLocumViewingPractice(state) {
			return state.locumViewingPractice;
		},

		getLocumPracticeRequestSelected(state) {
			return state.locumPracticeRequestSelected;
		},

		getLocumPracticeRequestAvailabilitySelected(state) {
			return state.locumPracticeRequestSelected;
		},
		getSelectedBooking(state) {
			return state.selectedBooking;
		},

		getCognitoUserGroups(state) {
			return state.cognitoUserGroups;
		},
		getWalletLabel(_, getters) {
			const userType = Users.getUserType(getters.getCognitoUserGroups);
			return Wallet.getWalletLabelByUserType(userType);
		},
		getWallet(state, getters) {
			const userType = Users.getUserType(getters.getCognitoUserGroups);

			if (userType === Users.TYPES.PROFESSIONAL) {
				return new Wallet({
					type: Wallet.TYPES.PROFESSIONAL.value,
					transactions: state.user.walletTransactions,
				});
			}
			if (userType === Users.TYPES.COMPANY) {
				return new Wallet({
					type: Wallet.TYPES.COMPANY.value,
					transactions: state.company.walletTransactions,
				});
			}
			return new Wallet();
		},
		getAllCalendarEvents(state) {
			return state.calendar_events;
		},
		getCalStartDate(state) {
			return state.cal_start_date ? state.cal_start_date : null;
		},
		getCalEndDate(state) {
			return state.cal_end_date ? state.cal_end_date : null;
		},
		getRequestedAvailabilities(state) {
			return state.availabilities.filter(avail => avail.status == 'requested' || avail.status == 'partially-confirmed');
		},
		getAvailabilities(state) {
			return state.availabilities.filter(avail => avail.status == 'open');
		},
		getAllAvailabilities(state) {
			return state.availabilities;
		},
		getUnavailabilities(state) {
			return state.availabilities.filter(avail => avail.status == 'unavailable');
		},
		getOffers(state) {
			return state.offers;
		},
		getLocumApplicationsReceived(state) {
			let applicationsRecieved = [];
			state.offers
				.filter(set => 'offers_requests' in set)
				.forEach(offer => {
					offer.offers_requests.forEach(request => {
						applicationsRecieved = [...applicationsRecieved, { offer: offer, request: request }];
					});
				});
			return applicationsRecieved;
		},
		getLocumOffersPossible(state) {
			return state.offers.filter(
				set =>
					set.offer_type == 'public' &&
					(!('offers_requests' in set) || ('offers_requests' in set && !set.offers_requests.some(requestee => requestee.id == state.user.id)))
			);
		},
		getLocumBookingRequestsSent(state) {
			//locum sent these to practice
			let BRSent = [];
			state.offers
				.filter(set => 'offers_requests' in set)
				.forEach(offer => {
					offer.offers_requests.forEach(request => {
						if (request.id == state.user.id) {
							BRSent.push({ offer: offer, request: request });
						}
					});
				});

			return BRSent;
		},

		getPracticeBookingRequestsSent(state) {
			return state.booking_requests.filter(set => set.request.status == 'requested');
		},
		getPracticeBookingsUpcoming(state) {
			return state.bookings.filter(booking => {
				let isFuture = moment(booking.start_date).isAfter(moment());
				let notCancelled = booking.status != 'cancelled';
				return isFuture && notCancelled;
			});
		},
		getPracticeBookingsPast(state) {
			return state.bookings.filter(booking => {
				let isBefore = moment(booking.start_date).isSameOrBefore(moment());
				let notCancelled = booking.status != 'cancelled';
				return isBefore && notCancelled;
			});
		},
		getPracticeBookingsCancelled(state) {
			return state.bookings.filter(booking => {
				let isCancelled = booking.status == 'cancelled';
				return isCancelled;
			});
		},

		getLocumBookingRequestsRecieved(state) {
			return state.booking_requests.filter(set => set.request.status == 'requested');
		},
		getLocumBookingsUpcoming(state) {
			return state.bookings.filter(booking => {
				let notCancelled = booking.status != 'cancelled';
				let isFuture = moment(booking.start_date).isAfter(moment());
				return notCancelled && isFuture;
			});
		},
		getLocumBookingsPast(state) {
			return state.bookings.filter(booking => {
				let notCancelled = booking.status != 'cancelled';
				let isPast = moment(booking.start_date).isSameOrBefore(moment());
				return notCancelled && isPast;
			});
		},
		getLocumBookingsCancelled(state) {
			return state.bookings.filter(booking => {
				let isCancelled = booking.status == 'cancelled';
				return isCancelled;
			});
		},
		getProvinceRegions(state) {
			return state.provinces_regions;
		},
		getPublicHolidays(state) {
			return state.public_holidays;
		},
		getUserCompletedVerifiedStep(state, _, __, rootGetters) {
			let result = true;
			let fields = ['first_name', 'last_name', 'contact', 'email', 'industry', 'profession', 'professional_body', 'professional_number', 'idpassport'];
			let address_fields = ['province', 'region', 'suburb'];

			const tenant = rootGetters['tenant/tenant'];
			const hideRegistrationBodyField = tenant?.settings?.workflow?.professionalProfile?.hideRegistrationBodyField;
			const hideRegistrationNumberField = tenant?.settings?.workflow?.professionalProfile?.hideRegistrationNumberField;

			if (hideRegistrationBodyField) {
				fields = fields.filter(field => field !== 'professional_body');
			}
			if (hideRegistrationNumberField) {
				fields = fields.filter(field => field !== 'professional_number');
			}

			fields.forEach(field => {
				if (!(field in state.user) || !(field in state.user && state.user[field].length > 0)) {
					result = false;
				}
			});
			if ('address' in state.user) {
				address_fields.forEach(field => {
					if (!(field in state.user.address) || !(field in state.user.address && state.user.address[field].length > 0)) {
						result = false;
					}
				});
			} else {
				result = false;
			}
			return result;
		},
		getCompanyCompletedVerifiedStep(state) {
			let result = state.companies?.length > 0;
			return result;
		},

		getLevels(state) {
			return state.professionalSteps.levels;
		},

		getLevelsCompany(state) {
			return state.companySteps.levels;
		},

		stepsRequired(state) {
			return state.professionalSteps.required_forms;
		},

		stepsRequiredCompany(_, getters) {
			return getters.companySteps.required_forms;
		},

		stepsBoosted(_, getters) {
			return getters.professionalSteps.booster_forms;
		},

		currentStep(state) {
			return state.professionalSteps.context;
		},
		currentStepCompany(state) {
			return state.companySteps.context;
		},

		getNextSignupStep(state) {
			return state.professionalSteps.nextRequiredStep;
		},
		getNextSignupStepCompany(state) {
			return state.companySteps.nextRequiredStep;
		},

		getNextBoosterSignupStep(state) {
			return state.professionalSteps.nextBoosterStep;
		},

		getIsApproved(state) {
			return 'approved' in state.user ? state.user.approved : false;
		},

		getIsApprovedCompany() {
			return true;
		},

		getTest(state) {
			return state.test;
		},

		user(state) {
			return state.user;
		},

		tenant: state => state.user?.['custom:tenant'],

		company(state) {
			return state.company;
		},

		companies(state) {
			return state.companies;
		},

		jwtToken: state => state.jwtToken,

		configs: state => state.configs,

		getConfirmedBookings: state => state.confirmedBookings,

		getProfileButtonColours: state => state.profileButtonColours,

		professionalSteps: (state, _, __, rootGetters) => ({
			...state.professionalSteps,
			booster_forms: state.professionalSteps.booster_forms.map(form => {
				const tenant = rootGetters['tenant/tenant'];
				if (form.context === 'education-step') {
					return {
						...form,
						text: tenant?.getLabel('educationSectionButton', form.text),
						button_text: tenant?.getLabel('educationSectionButton', form.button_text),
					};
				}
				return form;
			}),
		}),

		companySteps: (state, _, __, rootGetters) => ({
			...state.companySteps,
			required_forms: state.companySteps.required_forms.map(form => {
				const tenant = rootGetters['tenant/tenant'];
				if (form.context === 'address-step') {
					return {
						...form,
						text: tenant?.getLabel('companyAddress', form.text),
						button_text: tenant?.getLabel('companyAddress', form.button_text),
					};
				}

				if (form.context === 'about-step') {
					return {
						...form,
						button_text: tenant?.getLabel('companyAboutSectionButton', form.button_text),
					};
				}
				return form;
			}),
		}),
	},
};

export default store;
